import { tablesApi } from 'entities/table/api/tablesApi';
import cloneDeep from 'lodash-es/cloneDeep';
import { makeAutoObservable } from 'mobx';
import {
  TableLinkData,
  TableLinkModel,
} from 'entities/table/model/tableLinkModel';

export type UpdateTableParams = {
  id: string;
  name?: string;
  folder_id?: string | null;
  section_id?: string | null;
  links?: TableLinkData[];
};

export interface TableUpdatable {
  id: string;
  name: string;
  section_id: string | null;
  folder_id: string | null;
}

export class UpdateTableHelper {
  private _file: TableUpdatable;

  constructor(file: TableUpdatable) {
    this._file = file;
    makeAutoObservable(this);
  }

  public async update(params: UpdateTableParams) {
    try {
      const clone = cloneDeep(params);

      if (clone.folder_id) {
        delete clone.section_id;
      }
      if (clone.section_id) {
        delete clone.folder_id;
      }

      return await tablesApi.update(this._file.id, clone);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
